var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewpage",attrs:{"cur-view":_vm.curView}},[_c(_vm.curView,{key:_vm.curView,tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }